import React from 'react';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import { BodyS } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/topUpAddOns/limitExceededCardStyle';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import Button from 'components/CustomButtons/Button';
import ArrowRight from '@material-ui/icons/KeyboardArrowRight';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ILimitExceededCardProps {
	itemsToChange: types.topUpAddOns.ItemToChange[];
}

const LimitExceededCard = ({ itemsToChange }: ILimitExceededCardProps) => {
	const classes = useStyles();

	return (
		<Card className={classes.card}>
			<CardBody className={classes.cardBody}>
				<BodyS disableMargin color="danger">
					{translate('top.up.add.ons.limit.exceeded.text1')}
				</BodyS>
				<BodyS disableMargin color="danger">
					{translate('top.up.add.ons.limit.exceeded.text2')}
				</BodyS>
				<div className={classes.itemsToChangeWrapper}>
					{itemsToChange.map(({ text, onClick }, index) => (
						<ConditionalRender
							key={index}
							show={!!onClick}
							onTrue={() => (
								<Button color="tertiary-danger" withIcon onClick={onClick} className={classes.button}>
									<>
										{text}
										<ArrowRight />
									</>
								</Button>
							)}
							onFalse={() => (
								<BodyS color="danger" disableMargin>
									{text}
								</BodyS>
							)}
						/>
					))}
				</div>
			</CardBody>
		</Card>
	);
};

export default LimitExceededCard;
